import './custom-loader.css'
import * as React from 'react'
import { TailSpin, ThreeDots } from 'react-loader-spinner'
import { useState } from 'react';
import { useEffect } from 'react';
import { loaderSubject } from '.';

export const ReactLoader = (props) => {
  const [visibleCount, setVisible] = useState(props.visibleCount);

  useEffect(() => {
    loaderSubject.subscribe({
      next: (visible) => visible ? setVisible(prevCount => prevCount + 1) : setVisible(prevCount => Math.max(prevCount - 1, 0))
    })
  }, [visibleCount]);

  return (
    <React.Fragment>
      {visibleCount > 0 ? <div className='loader_overlay'></div> : null}
      <div className='loader_icon'>
        <ThreeDots
          height="80"
          width="80"
          radius="9"
          color="#009A4E"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClassName=""
          visible={visibleCount > 0 ? true : false }
        />
        {/* <TailSpin visible={visible} height={80} color="green"></TailSpin> */}
      </div>
    </React.Fragment>

  );
};
